export const SUBCAT_REDIRECTED_BANNER = {
  noLiveDeals: (categoryName) =>
    `Sorry there are no live deals for that category. Here are similar deals in ${categoryName}.`,
};
